import { StepProps } from 'antd';
import { SignatureRequestQuickFlowDrawerSteps } from '../../../constants';
import { t } from '../../../util';
export const getStepsConfig = (signatureMetadata): StepProps[] => {
	if (!signatureMetadata) {
		return [];
	}

	const { currentStep, completedSteps = [] } = signatureMetadata;

	const mappedCompletedSteps: StepProps[] = completedSteps.map(step => {
		return {
			title: step,
			status: 'finish',
			icon: 'CheckCircleFilled',
		};
	});

	const steps: StepProps[] = [
		...mappedCompletedSteps,
		{
			title: t('sendSignatureRequestQuickFlow.header.addRecipients'),
			status:
				currentStep === SignatureRequestQuickFlowDrawerSteps.AddRecipients
					? 'process'
					: currentStep === SignatureRequestQuickFlowDrawerSteps.ReviewAndSend
					? 'finish'
					: 'wait',
			icon:
				currentStep === SignatureRequestQuickFlowDrawerSteps.ReviewAndSend
					? 'CheckCircleFilled'
					: 'Users',
		},
		{
			title: t('sendSignatureRequestQuickFlow.header.reviewAndSend'),
			status:
				currentStep === SignatureRequestQuickFlowDrawerSteps.ReviewAndSend
					? 'process'
					: 'wait',
			icon: 'UserFeedback',
		},
	];

	return steps;
};
